var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"dev-status-row"},[_c('el-col',{attrs:{"span":24}},[_c('div',{ref:"myRef5",staticClass:"chart-box",attrs:{"id":"pieChart5"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }